module.exports = __webpack_public_path__ + "static/media/ViaMaisLogo.0a8640d9.png";